import type { SVGProps } from 'react';

export const MenuIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M1.66654 5.99986C1.66654 5.07939 2.41273 4.3332 3.3332 4.3332H20.6665C21.587 4.3332 22.3332 5.07939 22.3332 5.99986C22.3332 6.92033 21.587 7.66652 20.6665 7.66652H3.3332C2.41273 7.66652 1.66654 6.92033 1.66654 5.99986ZM1.66655 11.9998C1.66655 11.0794 2.41274 10.3332 3.33321 10.3332H20.6665C21.587 10.3332 22.3332 11.0794 22.3332 11.9998C22.3332 12.9203 21.587 13.6665 20.6665 13.6665H3.33321C2.41274 13.6665 1.66655 12.9203 1.66655 11.9998ZM3.33321 16.3332C2.41274 16.3332 1.66655 17.0794 1.66655 17.9998C1.66655 18.9203 2.41274 19.6665 3.33321 19.6665H20.6665C21.587 19.6665 22.3332 18.9203 22.3332 17.9998C22.3332 17.0794 21.587 16.3332 20.6665 16.3332H3.33321Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
